import React, { useEffect, useState } from 'react';
import { Loader2, AlertTriangle, RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { setDemoSession } from '../lib/session';

// Automotive INSURANCE BROKER entry — no-login. Mints the demo broker session
// (role='salesperson' + is_insurance_broker, scoped to auto-demo-org-0001) and
// lands on the same Sales Desk a salesperson gets — which then contains ONLY
// insurance conversations. Run it next to /demo/automotive/command-center to
// show the confidentiality boundary live: the manager sees the signal, the
// broker sees the thread.
export default function DemoAutoInsuranceBrokerEntry() {
    const { t } = useTranslation();
    const [error, setError] = useState(null);

    const enter = async () => {
        setError(null);
        const API = (typeof window !== 'undefined' ? window.location.origin : '');
        try { localStorage.setItem('yulontap-theme-preference', 'dark'); } catch (_e) { /* ignore */ }
        document.documentElement.classList.add('dark');
        const params = new URLSearchParams(window.location.search);
        const rawReturn = params.get('return_url') || '';
        const returnUrl = rawReturn.startsWith('/') && !rawReturn.startsWith('//') ? rawReturn : '';
        try {
            const qs = returnUrl ? `?return_url=${encodeURIComponent(returnUrl)}` : '';
            const res = await fetch(`${API}/api/demo-auto/insurance-broker/session${qs}`);
            let d = {};
            try { d = await res.json(); } catch (_e) { /* non-JSON body */ }
            if (!res.ok || !d.access_token) {
                throw new Error(`HTTP ${res.status}${d.detail ? ` — ${d.detail}` : ''}`);
            }
            setDemoSession(d.access_token, d.user || {});
            sessionStorage.setItem('yulontap_demo_mode', '1');
            sessionStorage.setItem('yulontap_auto_demo', '1');
            sessionStorage.removeItem('yulontap_hotel_demo');
            if (returnUrl) sessionStorage.setItem('yulontap_demo_return', returnUrl);
            else sessionStorage.removeItem('yulontap_demo_return');
            window.location.replace('/sales-desk');
        } catch (e) {
            setError(e.message || 'Network error');
        }
    };

    useEffect(() => { enter(); }, []);

    if (error) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-slate-950 text-slate-200 px-6 text-center"
                data-testid="demo-auto-broker-error">
                <AlertTriangle className="w-9 h-9 text-amber-400" />
                <p className="text-base font-semibold text-white">{t('demoAuto.brokerEntryFailedTitle', 'Could not open the Insurance Desk demo')}</p>
                <code className="text-xs text-rose-300 bg-black/40 rounded px-3 py-1.5" data-testid="demo-auto-broker-error-detail">{error}</code>
                <button onClick={enter} data-testid="demo-auto-broker-retry"
                    className="mt-2 inline-flex items-center gap-2 text-sm text-white bg-amber-600 hover:bg-amber-500 rounded-full px-4 py-2 transition-colors">
                    <RefreshCw className="w-4 h-4" />{t('demoAuto.entryRetry', 'Try again')}
                </button>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-slate-950 text-slate-200"
            data-testid="demo-auto-broker-entry">
            <Loader2 className="w-8 h-8 animate-spin text-amber-400" />
            <p className="text-sm">{t('demoAuto.enteringBroker', 'Opening Insurance Desk…')}</p>
        </div>
    );
}
